import { BusinessOnboardingDetails } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { BusinessIdentificationForm } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessIdentification/components/BusinessIdentificationForm';
import {
  BusinessIdentificationFormSchema,
  BusinessIdentificationFormType,
} from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessIdentification/schemas/BusinessIdentificationFormSchema';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { removeNullKeysFromObject } from '@/utils/removeNullKeysFromObject';

interface BusinessIdentificationWrapperProps {
  businessDetails: BusinessOnboardingDetails;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog: () => void;
  setBusinessDetailsToOnboardingDetails: (data) => void;
  loading?: boolean;
}

export const BusinessIdentificationEditDialog = ({
  businessDetails,
  opened,
  setOpened,
  toggleDialog,
  setBusinessDetailsToOnboardingDetails,
  loading,
}: BusinessIdentificationWrapperProps) => {
  const businessDetailsValues = businessDetails.businessDetails;

  if (!businessDetailsValues) return null;

  const businessIdentificationDefaultValues = {
    businessName: businessDetailsValues.businessName,
    nationalIdType: businessDetailsValues.nationalIdNumber.type,
    nationalIdNumber: businessDetailsValues.nationalIdNumber.number,
    nationality: businessDetailsValues.nationalIdNumber.nationality,
    companyActivity: businessDetailsValues.companyActivity,
    businessType: businessDetailsValues.businessType,
  };

  const onSubmitForm = async (formValues: BusinessIdentificationFormType) => {
    const onboardingDetails = {
      ...businessDetailsValues,
      address: businessDetailsValues
        ? { ...businessDetailsValues.address, formatted: businessDetailsValues.address.formattedAddress }
        : null,
      id: businessDetails.id,
      businessName: formValues.businessName,
      nationalIdNumber: {
        nationality: formValues.nationality,
        number: formValues.nationalIdNumber,
        type: formValues.nationalIdType,
      },
      companyActivity: formValues.companyActivity,
      businessType: formValues.businessType,
    };
    await setBusinessDetailsToOnboardingDetails(removeNullKeysFromObject(onboardingDetails));
    toggleDialog();
  };

  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={'EDIT_BUSINESS_IDENTIFICATION'}
      onSubmitForm={onSubmitForm}
      isLoading={loading}
      defaultValues={businessIdentificationDefaultValues}
      formSchema={BusinessIdentificationFormSchema}
    >
      <BusinessIdentificationForm businessDetails={businessDetailsValues} fullWidth fieldVariant={FieldVariant.form} />
    </EditDialogWrapper>
  );
};
